import { SpliteButton } from "@/components";
import { useDesignMaxTheme } from "@/packages";
import { useNewNavigate } from "@/shared/client";
import { Box, Center, Flex, Text } from "@chakra-ui/react";
import DOMPurify from "dompurify";
import { type OtherSpecialPreviewProps } from "./otherSpecialPreview.type";

export const OtherSpecial = ({ specials }: OtherSpecialPreviewProps) => {
    const { onNavigate } = useNewNavigate();
    const { MEDIAS } = useDesignMaxTheme();
    const { isMobile, isTablet } = MEDIAS();

    return (
        <Center
            position="relative"
            w="100%"
            borderTopLeftRadius={isMobile ? "0" : "56px"}
            background="#fbf6f2"
            p="80px 0"
        >
            <Flex as="section" flexDir="column">
                {specials.map((special, index) => {
                    const is2nth = index % 2 === 1;
                    return (
                        <Flex
                            maxW="none !important"
                            w="100% !important"
                            key={special.special_idx}
                            // eslint-disable-next-line no-nested-ternary
                            flexDir={isTablet ? "column" : is2nth ? "row-reverse" : "row"}
                            p="16px 0"
                            _hover={{
                                background: "#fff",
                                [`[data-role="img${index}"]`]: {
                                    opacity: "0.8",
                                },
                                borderBottomRightRadius: is2nth ? "0" : "56px",
                                borderTopLeftRadius: is2nth ? "56px" : "0",
                            }}
                        >
                            <Box
                                w={isTablet ? "100%" : "760px"}
                                // eslint-disable-next-line no-nested-ternary
                                h={isMobile ? "256px" : isTablet ? "364PX" : "572px"}
                                background={
                                    special.imgList[0]
                                        ? `url(${special.imgList[0].img_URL})no-repeat center/cover`
                                        : "gray.100"
                                }
                                // eslint-disable-next-line no-nested-ternary
                                borderTopRightRadius={is2nth ? "0" : isTablet ? "24px" : "88px"}
                                // eslint-disable-next-line no-nested-ternary
                                borderBottomLeftRadius={is2nth ? (isTablet ? "24px" : "88px") : "0"}
                            />
                            <Center
                                flex="1"
                                justifyContent="space-between"
                                flexDir={is2nth ? "row-reverse" : "row"}
                                p={isTablet ? "16px 0 0 0" : "0"}
                            >
                                <Flex flexDir="column" alignItems={is2nth ? "flex-end" : "flex-start"} gap="48px">
                                    <Flex
                                        alignItems={is2nth ? "flex-end" : "flex-start"}
                                        flexDir="column"
                                        rowGap={isMobile ? "12px" : "24px"}
                                        pl={is2nth ? "0" : "136px"}
                                        pr={is2nth ? "136px" : "0"}
                                        p={isTablet ? "0 16px" : "auto"}
                                        textAlign={is2nth ? "right" : "left"}
                                        sx={{
                                            "& p": {
                                                fontFamily: "Noto Serif KR",
                                                fontWeight: "400",
                                                lineHeight: "140%",
                                                color: "#664628",
                                            },
                                        }}
                                    >
                                        <Flex flexDir="column" gap={isMobile ? "0" : "8px"}>
                                            <Text fontSize={isMobile ? "14px" : "24px"}>
                                                {special.special_name.eng}
                                            </Text>
                                            <Text fontSize={isMobile ? "20px" : "40px"} fontWeight="600">
                                                {special.special_name.kor}
                                            </Text>
                                        </Flex>
                                        <Text
                                            dangerouslySetInnerHTML={{
                                                __html: DOMPurify.sanitize(
                                                    special.title.kor.replace(/\r?\n/g, "<br />"),
                                                ),
                                            }}
                                            fontSize="16px"
                                            color="#333 !important"
                                        ></Text>
                                    </Flex>
                                    <SpliteButton
                                        direction={index % 2 === 1 ? "reverse" : undefined}
                                        text="More View"
                                        textBackGroundColor="#fbf6f2"
                                        onClick={() => onNavigate({ path: `/specials/${special.special_idx}` })}
                                    />
                                </Flex>
                                <Center
                                    display={isTablet ? "none" : "flex"}
                                    data-role={`img${index}`}
                                    opacity="0"
                                    w="480px"
                                    h="360px"
                                    background={
                                        special.imgList[1]
                                            ? `url(${special.imgList[1].img_URL})no-repeat center/cover`
                                            : "none"
                                    }
                                    transition="opacity 0.8s ease-in-out"
                                    borderBottomLeftRadius={is2nth ? "0" : "88px"}
                                    borderTopRightRadius={is2nth ? "88px" : "0"}
                                >
                                    {/* {!special.imgList[1] && <Text>등록된 이미지가 없습니다.</Text>} */}
                                </Center>
                            </Center>
                        </Flex>
                    );
                })}
            </Flex>
        </Center>
    );
};
